require('./bootstrap');

// Vendor Imports
import { createApp } from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import * as FullStory from '@fullstory/browser';

FullStory.init({ orgId: '1528T5' });

// Local Imports
import App from '@/App.vue'
import router from '@/router'
import store from '@/store/index'

const app = createApp(App)
    .use(router)
    .use(store)
    .use(VueAxios, axios)

app.config.globalProperties.$FullStory = FullStory;

app.mount('#app');
